export { default } from './isImmutableIterable'
